module.exports = __webpack_public_path__ + "img/RTF.4d5b1deb.gif";